import cn from 'classnames'
import type { ReactNode } from 'react'

import styles from './CockpitEmptyState.module.scss'

interface ICockpitEmptyStateProps {
  title: ReactNode
  subtitle?: ReactNode
  /** A kbase icon class, or a mark of its own. Left out, the state is its words alone. */
  icon?: string | ReactNode
  positive?: boolean
}

export const CockpitEmptyState = ({
  title,
  subtitle,
  icon,
  positive = false,
}: ICockpitEmptyStateProps) => (
  <div className={styles.root}>
    {typeof icon === 'string' ? (
      <i className={cn(icon, styles.icon, { [styles.positive]: positive })} />
    ) : (
      icon
    )}
    <span className={styles.title}>{title}</span>
    {subtitle != null && <span className={styles.subtitle}>{subtitle}</span>}
  </div>
)
